import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { withJsonpSupport } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';

import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainFooterComponent } from './components/main-footer/main-footer.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { PassViewerPageComponent } from './pages/pass-viewer-page/pass-viewer-page.component';
import { PaymentFailurePageComponent } from './pages/payment-failure-page/payment-failure-page.component';
import { PaymentSuccessPageComponent } from './pages/payment-success-page/payment-success-page.component';
import { PrivacyPolicyPageComponent } from './pages/privacy-policy-page/privacy-policy-page.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';

@NgModule({
  declarations: [
    AppComponent,
    MainFooterComponent,
    MainLayoutComponent,
    PassViewerPageComponent,
    PaymentFailurePageComponent,
    PaymentSuccessPageComponent,
    PrivacyPolicyPageComponent,
    SpinnerComponent,
    ToastsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    QRCodeModule,
    NgbModule
  ],
  providers: [
    provideHttpClient(withJsonpSupport()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
